"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Dialog = _interopRequireDefault(require("material-ui/Dialog"));

var _classnames = _interopRequireDefault(require("classnames"));

var _close = _interopRequireDefault(require("react-icons/lib/io/close"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DashModal = function DashModal(_ref) {
  var isOpen = _ref.isOpen,
      title = _ref.title,
      children = _ref.children,
      _ref$handleClose = _ref.handleClose,
      handleClose = _ref$handleClose === void 0 ? function () {} : _ref$handleClose,
      className = _ref.className,
      _ref$isModal = _ref.isModal,
      isModal = _ref$isModal === void 0 ? true : _ref$isModal;

  var modalHeader = /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-header"
  }, title, /*#__PURE__*/_react.default.createElement(_close.default, {
    className: "dash-modal-close-button",
    onClick: handleClose
  }));

  return /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    modal: isModal,
    autoScrollBodyContent: true,
    open: isOpen,
    title: modalHeader,
    className: (0, _classnames.default)('dash-modal', className),
    bodyClassName: "modal-body",
    contentClassName: "modal-content",
    onRequestClose: handleClose
  }, children);
};

var _default = DashModal;
exports.default = _default;